import React from 'react';
import { Button } from 'react-style-guide';
import { playGameService } from 'core-roblox-utilities';
import PropTypes from 'prop-types';

const HoverGameTileContents = props => {
  const { gameDescription, placeId } = props;

  return (
    <div data-testid='game-tile-hover-game-tile-contents' className='game-card-contents'>
      {gameDescription && <p className='game-description font-caption-header'>{gameDescription}</p>}
      <Button
        width={Button.widths.full}
        variant={Button.variants.growth}
        size={Button.sizes.extraSmall}
        onClick={() => {
          playGameService.launchGame(playGameService.buildPlayGameProperties(undefined, placeId), {
            eventName: 'playGameClicked',
            ctx: 'click',
            properties: {
              placeId
            },
            gamePlayIntentEventCtx: 'PlayButton'
          });
        }}>
        <span className='icon-common-play' />
      </Button>
    </div>
  );
};

HoverGameTileContents.defaultProps = {
  gameDescription: null
};

HoverGameTileContents.propTypes = {
  gameDescription: PropTypes.string,
  placeId: PropTypes.number.isRequired
};

export default HoverGameTileContents;
